/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({"data":{"categories":{"cardinal":["few","many","one","other","two"],"ordinal":["other"]},"fn":function(num, isOrdinal, exponent = 0) {
    const numStr = String(num);
    const parts = numStr.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1] || "";
    const n = Math.abs(parseFloat(numStr));
    if (isOrdinal) {
    }
    else {
        if ((((n % 10) >= 3 && (n % 10) <= 4) || (n % 10) === 9) && ((((n % 100) < 10 || (n % 100) > 19) && ((n % 100) < 70 || (n % 100) > 79)) && ((n % 100) < 90 || (n % 100) > 99)))
            return "few";
        if (n !== 0 && (n % 1000000) === 0)
            return "many";
        if ((n % 10) === 1 && (((n % 100) !== 11 && (n % 100) !== 71) && (n % 100) !== 91))
            return "one";
        if ((n % 10) === 2 && (((n % 100) !== 12 && (n % 100) !== 72) && (n % 100) !== 92))
            return "two";
    }
    return "other";
}},"locale":"br"})
} else {
  (globalThis.__FORMATJS_PLURALRULES_DATA__ = globalThis.__FORMATJS_PLURALRULES_DATA__ || []).push({"data":{"categories":{"cardinal":["few","many","one","other","two"],"ordinal":["other"]},"fn":function(num, isOrdinal, exponent = 0) {
    const numStr = String(num);
    const parts = numStr.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1] || "";
    const n = Math.abs(parseFloat(numStr));
    if (isOrdinal) {
    }
    else {
        if ((((n % 10) >= 3 && (n % 10) <= 4) || (n % 10) === 9) && ((((n % 100) < 10 || (n % 100) > 19) && ((n % 100) < 70 || (n % 100) > 79)) && ((n % 100) < 90 || (n % 100) > 99)))
            return "few";
        if (n !== 0 && (n % 1000000) === 0)
            return "many";
        if ((n % 10) === 1 && (((n % 100) !== 11 && (n % 100) !== 71) && (n % 100) !== 91))
            return "one";
        if ((n % 10) === 2 && (((n % 100) !== 12 && (n % 100) !== 72) && (n % 100) !== 92))
            return "two";
    }
    return "other";
}},"locale":"br"})
}
